import { ClassicPreset, GetSchemes } from 'rete';
import { SelectableConnection } from '../connections/models/SelectableConnection';
import { DesignerSelection } from '../models/designer-selection';
import { ReteContext } from '../models/rete-context';
import { SocketSelection } from './socket-selection';

type Schemes = GetSchemes<ClassicPreset.Node, ClassicPreset.Connection<ClassicPreset.Node, ClassicPreset.Node>>;

/**
 * Gestionnaire de la selection du designer de workflow.
 */
export class SelectionHandler {
    /**
     * Contexte d'execution du designer de workflow.
     */
    public context: ReteContext;

    private _selection: DesignerSelection;

    public clearSelection() {
        this.updateCurrentNodeSelectedProperty(false);
        this.updateCurrentConnectionSelectedProperty(false);
        this._selection = new DesignerSelection(null, null, null, this._selection);
    }

    public get selection(): DesignerSelection {
        return this._selection;
    }

    /**
     * Deselectionne la connexion actuellement selectionnée.
     */
    public unselectCurrentConnection() {
        if (this._selection?.selectedConnection) {
            this.updateCurrentConnectionSelectedProperty(false);
            this._selection = new DesignerSelection(null, null, null, this._selection);
        }
    }

    /**
     * Met à jour la propriété selected du noeud selectionné.
     */
    private updateCurrentNodeSelectedProperty(value: boolean) {
        if (this._selection?.selectedNode) {
            this._selection.selectedNode.selected = value;
            this.context.area.update('node', this._selection.selectedNode.id);
        }
    }

    /**
     * Met à jour la propriété selected de la connexion selectionnée.
     */
    private updateCurrentConnectionSelectedProperty(value: boolean) {
        if (this._selection?.selectedConnection) {
            this._selection.selectedConnection.selected = value;
            this.context.area.update('connection', this._selection.selectedConnection.id);
        }
    }

    /**
     * Deselectionne le noeud actuellement selectionné.
     */
    public unselectCurrentNode() {
        this.updateCurrentNodeSelectedProperty(false);
        this._selection = new DesignerSelection(null, null, null, this._selection);
    }

    /**
     * Selectionne le noeud specifié.
     */
    public selectNode(node: Schemes['Node']) {
        this.updateCurrentNodeSelectedProperty(false);
        this.updateCurrentConnectionSelectedProperty(false);
        node.selected = true;
        if (node.id !== this._selection?.selectedNode?.id) {
            // Met à jour la selection uniquement si le noeud selectionné a changé.
            this._selection = new DesignerSelection(node, null, null, this._selection);
        }
    }

    /**
     * Selectionne la connexion specifiée.
     */
    public selectConnection(connexion: SelectableConnection) {
        this.updateCurrentNodeSelectedProperty(false);
        this.updateCurrentConnectionSelectedProperty(false);
        connexion.selected = true;
        // this.context.area.update('connection', connexion.id);
        this._selection = new DesignerSelection(null, connexion, null, this._selection);
    }

    /**
     * Selectionne la socket specifiée.
     */
    public selectSocket(socket: SocketSelection) {
        this._selection = new DesignerSelection(null, null, socket, this._selection);
    }
}
